import React from "react";
function Header(props) {
  return (
    <>
      <header>
        <div className="container-lg g-lg-0">
        <a href="/">
          <img
            src={props.path}
            alt="ICICI Bank Logo"
            width={252}
            height={50}
            className="img-fluid"
          />
        </a>
        </div>
      </header>
    </>
  );
}

export default Header;
